import {
  httpClient,
  apiRoutes,
  type DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { SubscriptionDetailResponse } from './types';

export const getSubscriptionDetailFn = async (id: string) => {
  const response = await httpClient.get<SubscriptionDetailResponse>(
    apiRoutes.subscription.subscription_detail(id)
  );
  return response.data;
};

export const useGetSubscriptionDetail = (
  id: string,
  opts?: Omit<
    UseQueryOptions<SubscriptionDetailResponse, DefaultQueryError>,
    'queryKey'
  >
) =>
  useQuery<SubscriptionDetailResponse, DefaultQueryError>({
    queryKey: [apiRoutes.subscription.subscription_detail(id)],
    queryFn: () => getSubscriptionDetailFn(id),
    ...opts,
  });
